export const getDetail = state => state.detail;
export const getSelectedDetailOwnerId = state => {
  var _getDetail;
  return (_getDetail = getDetail(state)) === null || _getDetail === void 0 ? void 0 : _getDetail.selectedDetailOwnerId;
};